import React from "react";
import Byj from "../assets/images/3g_byj.png";


const ByjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">三柜摆药机</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>设计理念</h3>
              <p className="team-details__text">
                结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。
                部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。
                模块化设计，手自动模式独立控制，保证药品的存取安全。
                所有子系统均要满足软件硬件double-check的原则，以保证系统的稳定可靠杜绝故障的发生。
              </p>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>产品特点</h3>
              <strong style={{ color: "black" }}>立体式存储</strong>:
              高效利用空间，实现药品立体存储，解决PIVAS场地问题。<br />
              <strong style={{ color: "black" }}>全自动、半自动一体：</strong>
              改变“人找药品”的模式，实现“用什么药品，出什么药品” 手动、自动双模式，实时按指令动作。<br />
              <strong style={{ color: "black" }}>信息化：</strong>
              全方位多元化管理，实时查询药品的储量、批次、效期发放等相关信息。<br />
              <strong style={{ color: "black" }}>高效性：</strong>
              设备采用多单元并行回转，在接到处方信息后系统可单独或同时运转，到达所处位置后自动提示取药。效率较市面上一体式存储系统提高2-3倍。<br />
            </div>
          </div>
          <div className="col-lg-6">
            {/* <h3 style={{color:"black"}}>运用场景智能三柜摆药机</h3> */}
            <h2 className="team-details__title">运用场景</h2>
            <p className="team-details__text">
              自动接收医嘱信息，通过大数据分析过往医嘱信息，智能规划最合理药品仓位，统筹兼顾统排、散排、单人取药、多人取药、单药、多药等模式。</p><br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={Byj} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/byj-details">智能三柜摆药机</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ByjDetails;
